
import React from 'react'
import {Link} from 'react-router-dom';
import AboutUs from '../../../Pages/AboutUs';
import TermAndConditions from '../../../Pages/TermAndConditions';
import Signout from '../../Signout';
import d7 from './FooterMenuContent.module.css'

function FooterMenuContent(props) {
    return (
        <div className={d7.container}>
        <ul >
         <li ><Link to=''><Signout>Log out</Signout></Link></li>
         <li onClick={props.onClick}><Link to='/about-us' element={<TermAndConditions/>}>About Us</Link></li>
         <li onClick={props.onClick}><Link to='/terms-conditions' elemnet={<AboutUs/>}>Terms & conditions</Link></li>
        </ul>    
        </div>
    )
}

export default FooterMenuContent
